import styled from 'styled-components';

export const IconWrapper = styled.div`
  display: grid;
  place-items: center;

  height: ${({ height }) => height};
  width: ${({ width }) => width};
  background-color: ${({ theme }) => theme.colors.gray};
  border-radius: ${({ radius }) => radius};
  border: 2px solid transparent;
  cursor: pointer;

  :hover {
    border-color: ${({ theme }) => theme.colors.purple};
  }
`;

IconWrapper.defaultProps = {
  height: '3rem',
  width: '3rem',
  radius: '50%'
  //   border: 'border: 2px solid transparent;'
};
